import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "items-matching-container"
};
const _hoisted_2 = ["draggable", "onDragstart", "onDragenter", "onDrop"];
const _hoisted_3 = {
  class: "reorder-icon-container"
};
const _hoisted_4 = {
  class: "item-value-container"
};
const _hoisted_5 = {
  class: "item-image-container"
};
const _hoisted_6 = {
  class: "matching-icon-container"
};
const _hoisted_7 = {
  class: "item-value-container"
};
const _hoisted_8 = {
  class: "item-image-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_question_answer_image_uploader = _resolveComponent("question-answer-image-uploader");
  const _component_w_input = _resolveComponent("w-input");
  const _component_confirm_dialog = _resolveComponent("confirm-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.realtimePairs, (pair, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: pair.position,
      class: _normalizeClass(['matching-pair', {
        'is-drag-over': index === _ctx.dragOverIndex
      }]),
      onMousedown: _cache[0] || (_cache[0] =
      //@ts-ignore
      (...args) => _ctx.handleMouseDown && _ctx.handleMouseDown(...args)),
      draggable: _ctx.isDraggable,
      onDragstart: $event => _ctx.onDragStart(index),
      onDragenter: _withModifiers($event => _ctx.onDragEnter(index), ["prevent"]),
      onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _withModifiers($event => _ctx.onDrop(index), ["prevent"]),
      onDragend: _cache[2] || (_cache[2] =
      //@ts-ignore
      (...args) => _ctx.onDragEnd && _ctx.onDragEnd(...args))
    }, [_createElementVNode("span", _hoisted_3, [_createVNode(_component_icon, {
      class: "reorder-icon",
      icon: "drag-vertical"
    })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_question_answer_image_uploader, {
      image: pair.itemImage,
      onImageUploaded: $event => _ctx.onItemImageChange($event, pair),
      onImageDelete: $event => _ctx.onItemImageDelete(pair)
    }, null, 8, ["image", "onImageUploaded", "onImageDelete"])]), _createVNode(_component_w_input, {
      class: _normalizeClass(['item-input pair-item-input', {
        'is-error': pair.isItemError
      }]),
      value: pair.itemImage ? pair.itemImage.imageLabel : pair.item,
      type: 'text',
      placeholder: _ctx.$t('chapter.question.matching.pairItemPlaceholder'),
      maxlength: _ctx.LABEL_NB_MAX_CHARS,
      onInputBlur: $event => _ctx.onPairItemBlur(pair, $event)
    }, null, 8, ["class", "value", "placeholder", "maxlength", "onInputBlur"])]), _createElementVNode("span", _hoisted_6, [_createVNode(_component_icon, {
      class: "matching-icon",
      icon: "ray-start-end"
    })]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_question_answer_image_uploader, {
      image: pair.itemResponseImage,
      onImageUploaded: $event => _ctx.onItemResponseImageChange($event, pair),
      onImageDelete: $event => _ctx.onItemResponseImageDelete(pair)
    }, null, 8, ["image", "onImageUploaded", "onImageDelete"])]), _createVNode(_component_w_input, {
      class: _normalizeClass(['item-input pair-item-response-input', {
        'is-error': pair.isItemResponseError
      }]),
      value: pair.itemResponseImage ? pair.itemResponseImage.imageLabel : pair.itemResponse,
      type: 'text',
      placeholder: _ctx.$t('chapter.question.matching.pairItemResponsePlaceholder'),
      maxlength: _ctx.LABEL_NB_MAX_CHARS,
      onInputBlur: $event => _ctx.onPairItemResponseBlur(pair, $event)
    }, null, 8, ["class", "value", "placeholder", "maxlength", "onInputBlur"])]), _createVNode(_component_icon, {
      class: "pair-delete-icon",
      icon: "delete-outline",
      disabled: _ctx.realtimePairs.length <= 2,
      onClick: $event => _ctx.deletePair(pair)
    }, null, 8, ["disabled", "onClick"])], 42, _hoisted_2);
  }), 128)), _createVNode(_component_confirm_dialog, {
    "v-if": _ctx.activePair && _ctx.displayPairDeletionDialog,
    visible: _ctx.displayPairDeletionDialog,
    title: _ctx.$t('chapter.question.matching.deletePair.modal.title'),
    message: _ctx.$t('chapter.question.matching.deletePair.modal.description'),
    "confirm-button-text": _ctx.$t('chapter.question.matching.deletePair.modal.validateBtn'),
    "cancel-button-text": _ctx.$t('chapter.question.matching.deletePair.modal.cancelBtn'),
    "close-on-outside-click": false,
    onOnConfirmed: _cache[3] || (_cache[3] = $event => _ctx.onPairDeleteConfirm()),
    onOnDialogClose: _cache[4] || (_cache[4] = $event => _ctx.onPairDeleteCancel()),
    onOnCanceled: _cache[5] || (_cache[5] = $event => _ctx.onPairDeleteCancel())
  }, null, 8, ["v-if", "visible", "title", "message", "confirm-button-text", "cancel-button-text"])]);
}